import Login from '@/utils/login';
import ROLE from '@/utils/roles';

export async function getCourseViewer(vm) {
  const role = Login.lastRole;

  if (role === ROLE.STUDENT) {
    return 'student';
  }
  if (role === ROLE.SCHOOL) {
    return 'school';
  }
  if (role === ROLE.TEACHER) {
    await vm.$teacher.getInfo();
    return vm.$teacher.isAdmin ? 'admin' : 'teacher';
  }
  return '';
}
